import { useMutation } from "@apollo/client";
import { ADD_FAVORITE, DELETE_FAVORITE } from "../graphQl/FavoritesAPI";
import { SERVICE_TYPE } from "../../../../../common/model/enum";

export const useToggleFavorite = () => {
  
  const [addFavoriteMutation] = useMutation(ADD_FAVORITE);
  const [deleteFavoriteMutation] = useMutation(DELETE_FAVORITE);

  /**
   * item = {
   *   id,
   *   isFavorite,
   *   favoriteId?,
   *   entityType
   * }
   */
  const toggleFavorite = async (personId, item) => {
    try {
      // Si pas favori → AJOUTER
      if (!item.isFavorite) {
        const result = await addFavoriteMutation({
          variables: {
            personId,
            favoriteInput: {
              entityId: item.id,
              entityType: SERVICE_TYPE.TRIP,
            },
          },
        });

        return {
          success: true,
          mode: "added",
          favorite: result?.data?.MT_ADD_FAVORITE?.data,
        };
      }

      // Si favori → SUPPRIMER
      await deleteFavoriteMutation({
        variables: {
          personId,
          favoriteId: item.favoriteId,
        },
      });

      return {
        success: true,
        mode: "deleted",
      };

    } catch (error) {
      console.error("Erreur toggleFavorite:", error);
      return { success: false, error };
    }
  };

  return { toggleFavorite };
};
